import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

//import 'rxjs';
//import { map, catchError } from 'rxjs/operators';
//import 'rxjs/add/operator/catch';

import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiRequestService } from './api-request.service';

@Injectable()
export class ApiPublicRequestService {

  constructor (
    private httpClient: HttpClient,
    private apiRequestService: ApiRequestService
  ) { }

   /**
   * GET GENERICO PARA USO DE TODOS OS SERVIÇOS, SEM ENVIO DE TOKEN
   * @param url string
   * @param urlParams URLSearchParams
   */
  get (url: string, params?: any) : Observable<any> {
    let parametros: any;
    if (typeof params !== 'undefined') {
      if (params.responseType === 'text') {
        parametros = {responseType: 'text'};
      }
    }
    return this.httpClient.get (this.apiRequestService.codificaUrl(url), parametros)
      .pipe(
        map((resposta: any) => {
          if (typeof params !== 'undefined' && params.responseType === 'text') {
            return JSON.stringify(resposta);
          }
          return resposta;
        }),
        catchError (error => {
          let header: HttpHeaders = new HttpHeaders();
          let body = null;
          return throwError({error, url, body, header, 'method': 'GET' });
        })        
      );
  }

  /**
   * GET GENERICO PARA USO DE TODOS OS SERVIÇOS SINCRONOS, SEM ENVIO DE TOKEN
   * @param url string
   * @param urlParams URLSearchParams
   */
  async getAsync (url: string, params?: any) : Promise<any> {
    try {
      let parametros: any;
      if (typeof params !== 'undefined') {
        if (params.responseType === 'text') {
          parametros = {responseType: 'text'};
        }
      }
      let ret = await this.httpClient.get(this.apiRequestService.codificaUrl(url), parametros).toPromise();
      if (typeof params !== 'undefined' && params.responseType === 'text') {
        return JSON.stringify(ret);
      }
      return ret;
    } catch (error) {
      throw error;
    }
  }

  listarGenerico (url: string, pagina?: number, tamanho?: number) {
    let link: string = "";
    if (pagina != null) {
      link = "&page=" + pagina;
    }
    if (pagina != null && tamanho != null) {
      link += "&size=" + tamanho;
    }

    if(url.indexOf('?') < 0 && link.length > 0) {
      link = link.replace('&', '/?');
    }
    return this.get(this.apiRequestService.codificaUrl(url + link));
  }

  post (url: string, objeto: Object, params?: any) : Observable<any> {
    let parametros: any;
    if (typeof params !== 'undefined') {
      if (params.responseType === 'text') {
        parametros = {responseType: 'text'};
      }
    }
    return this.httpClient.post (this.apiRequestService.codificaUrl(url), objeto, parametros)
      .pipe (
        map ((resposta: any) => {
          if (typeof params !== 'undefined' && params.responseType === 'text') {
            return JSON.stringify(resposta);
          }
            return resposta;
        }),
        catchError (error => {
          let header: HttpHeaders = new HttpHeaders();
          return throwError({error, url, objeto, header, 'method': 'POST' });
        })
      );      
  }

 put (url: string, objeto: Object, params?: any) : Observable<any> {
    let parametros: any;
    if (typeof params !== 'undefined') {
      if (params.responseType === 'text') {
        parametros = {responseType: 'text'};
      }
    }
    return this.httpClient.put (this.apiRequestService.codificaUrl(url), objeto, parametros)
    .pipe(
      map ((resposta: any)  => {
        if (typeof params !== 'undefined' && params.responseType === 'text') {
          return JSON.stringify(resposta);
        }
          return resposta;
      }),
      catchError(function(error: any) {
        let header: HttpHeaders = new HttpHeaders();
        return throwError({error, url, objeto, header, 'method': 'PUT' });
      })
    );
  }

  delete (url: string, params?: any) : Observable<any> {
    let parametros: any;
    if (typeof params !== 'undefined') {
      if (params.responseType === 'text') {
        parametros = {responseType: 'text'};
      }
    }
    return this.httpClient.delete (this.apiRequestService.codificaUrl(url), parametros)
    .pipe(
      map (resposta => resposta),
      catchError (error => {
        let header: HttpHeaders = new HttpHeaders();
        let objeto = null;
        return throwError({error, url, objeto, header, 'method': 'DELETE' });
      })
    );
  }

}